import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';

import profileIcon from './profile.png';
import profileIcon2x from './profile@2x.png';
import { getClientLogo, fallbackImgFunc } from '../../../utils/user';

const getAvatarProps = ogranizationName =>
  ogranizationName
    ? {
        src: getClientLogo(ogranizationName, '26x26'),
        onError: fallbackImgFunc
      }
    : {
        src: profileIcon,
        srcSet: `${profileIcon}, ${profileIcon2x} 2x`
      };

const ProfileMenu = ({ ogranizationName, onLogout, allowedPages }) => {
  const showProfile = allowedPages.includes('/profile');
  return (
    <Dropdown
      id="tvt-header__dropdown-profile"
      className="tvt-dropdown tvt-dropdown--light tvt-header__dropdown-profile"
      pullRight
    >
      <Dropdown.Toggle
        className="tvt-dropdown__btn tvt-header__dropdown-profile-avatar"
        noCaret
      >
        <img
          className="img-responsive"
          alt="User Profile"
          {...getAvatarProps(ogranizationName)}
        />
      </Dropdown.Toggle>

      <Dropdown.Menu className="tvt-dropdown__menu">
        {showProfile && (
          <MenuItem
            className="tvt-dropdown__menu-item"
            href="/profile"
            key="profile"
            to="/profile"
          >
            Profile
          </MenuItem>
        )}
        <MenuItem
          className="tvt-dropdown__menu-item"
          key="release-notes"
          to="/release-notes"
          href="/release-notes"
        >
          Release Notes
        </MenuItem>
        <MenuItem
          className="tvt-dropdown__menu-item"
          key="system-status"
          to="/system-status"
          href="/system-status"
        >
          System Status
        </MenuItem>
        <MenuItem className="tvt-dropdown__menu-item" onSelect={onLogout}>
          Log Out
        </MenuItem>
      </Dropdown.Menu>
    </Dropdown>
  );
};

ProfileMenu.propTypes = {
  ogranizationName: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
  allowedPages: PropTypes.arrayOf(PropTypes.string).isRequired
};

ProfileMenu.defaultProps = {
  ogranizationName: ''
};

export default ProfileMenu;
